module.exports = __webpack_public_path__ + "img/h2-3.19a49788.png";